import "core-js/modules/es.number.constructor";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import CommonTitle from '../common/CommonTitle/CommonTitle.vue';
export default {
  props: {
    num: {
      type: Number,
      default: 4
    }
  },
  components: {
    CommonTitle: CommonTitle
  },
  computed: {
    settingConfig: function settingConfig() {
      return window.setting.发电时刻;
    }
  },
  methods: {
    lookMyProps: function lookMyProps() {
      this.$report.click(this.reportData.道具玩法介绍.查看道具);
      var link = this.getConfig('跳转链接');
      this.openUrl(link);
    },
    getConfig: function getConfig(key) {
      if (this.isLiveEnd) {
        // eslint-disable-next-line no-param-reassign
        key = "\u70B9\u64AD\u671F".concat(key);
      }

      return this.settingConfig[key];
    },
    toBuy: function toBuy() {
      var top = 4 * config.rem;
      console.log(_typeof(window.scroll));

      if (config.optionSupported) {
        window.scroll({
          top: top,
          behavior: 'smooth'
        });
      } else {
        window.scroll(0, top);
      }
    }
  }
};